import VueCookies from 'vue-cookies';

export default class CookieService {

    static set(groupName, name, value, duration = '1M') {
        let cookieGroup = CookieService.get(groupName);
        cookieGroup[name] = value;
        VueCookies.set(groupName, cookieGroup, duration, null, null, null, 'Lax');
    }

    static remove(groupName) {
        VueCookies.remove(groupName);
    }

    static removeKey(groupName, name = null, duration = '1M') {
        let cookieGroup = CookieService.get(groupName);
        delete cookieGroup[name];
        VueCookies.set(groupName, cookieGroup, duration, null, null, null, 'Lax');
    }

    static has(groupName, name) {
        return VueCookies.isKey(groupName) && VueCookies.get(groupName)[name] !== undefined;
    }

    static get(groupName, name = null) {
        let cookieGroup = {};
        if (VueCookies.isKey(groupName)) {
            cookieGroup = VueCookies.get(groupName);
        }

        if (name !== null) {
            return cookieGroup[name] !== undefined ? cookieGroup[name] : null;
        }

        return cookieGroup;
    }
}